import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo, useState } from "react";
import { fetchImsNat, fetchImsNatForListe, fetchImsNatOnly, ImsNatDeleted, verifExistance } from "../../Redux/imsnatReduce";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import MaterialReactTable from 'material-react-table';
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import DownloadFileCell from "./DownloadFileCell";


function list_ImsNat({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    let lang = window.localStorage.getItem("lang");
    const t = useTranslation();
    const [loader, setLoader] = React.useState(true);
    const [alert, setAlert] = React.useState(null);
    const [entities, setEntities] = React.useState([]);
    const ans = JSON.parse(localStorage.getItem("annee"));



    const getinfo = useCallback(
        async (rowId) => {
            var root = await dispatch(fetchImsNatOnly({ id: rowId }));
            exportToexcel(root.payload.arrayPrixProd);
        },
        [dispatch]
    );

    const name = "imsNat";
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    const resultString = `${name} ${formattedDate}`;
    const fileName = resultString; // Define the file name
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

const exportToexcel = async (info) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    if (!info || info.length === 0) {
        return;
    }

    // Add headers
    const headers = Object.keys(info[0]);
    worksheet.addRow(headers);

    // Style header (optional but nice)
    worksheet.getRow(1).font = { bold: true };

    // Add rows
    info.forEach((item) => {
        worksheet.addRow(Object.values(item));
    });

    // Auto width columns
    worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
            const length = cell.value ? cell.value.toString().length : 10;
            if (length > maxLength) {
                maxLength = length;
            }
        });
        column.width = maxLength + 2;
    });

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};

    const columns = useMemo(
        () => [
            {
                header: "Nom file",
                accessorKey: "titre",
            },
            {
                header: "Mois",
                accessorKey: "mois",
            },
            {
                header: "Année",
                accessorKey: "annee",
            },
            {
                header: "Date insertion ",
                accessorKey: "createdAt",
            },
            {
                accessorKey: 'id',
                header: 'Détails',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        <Button
                            className=" mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={() => {
                                navigate.push(client + "/ImsNat/detail/" + cell.row.original.id);
                            }}
                        >
                            <i className="fas fa-eye"></i>
                        </Button>
                    </div>
                ),
            },
            {
                accessorKey: 'id',
                header: 'Télécharger Détail',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        <Button
                            className="btn-export  mr-1 float-left"
                            type="button"
                            onClick={() => {
                                getinfo(cell.row.original.id)
                            }}
                            style={{ cursor: "pointer", fontSize: 14 }}
                        >
                            <i class="fa-solid fa-file-excel"></i>
                        </Button>
                    </div>
                ),
            },
            {
                accessorKey: 'nom_file',
                header: 'Télécharger Fichier',
                Cell: ({ cell }) => (
                    <div className="actions-right block_action">
                        <DownloadFileCell nom_file={cell.row.original.nom_file} />
                    </div>
                ),
            },
            {
                accessorKey: 'id',
                header: 'Actions',
                Cell: ({ cell, row }) => (
                    <div className="actions-right block_action">
                        <Button
                            id={"idLigne_" + cell.row.original.id}
                            onClick={(e) => {
                                // confirmMessage(cell.row.original.id, e);
                                verif(cell.row.original.id)
                            }}
                            variant="danger"
                            size="sm"
                            className="text-danger btn-link delete"
                        >
                            <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
                        </Button>
                    </div>
                ),
            },
        ],
        [client]
    );

    const notify = (type, msg) => {
        if (type === 1)
            toast.success(
                <strong>{msg}</strong>
            );
        else
            toast.error(
                <strong>{msg}</strong>
            );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const confirmMessage = (id, e, test) => {
        setAlert(
            test === 1 ? (
                <SweetAlert
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Êtes-vous sûr de continuer la suppression ? "
                    onConfirm={() => deleteImsNat(id, e)}
                    onCancel={() => hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Oui"
                    cancelBtnText="Non"
                    showCancel
                />
            ) : (
                <SweetAlert
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Êtes-vous sûr de continuer la suppression ? "
                    onConfirm={() => deleteImsNat(id, e)}
                    onCancel={() => hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Oui"
                    cancelBtnText="Non"
                    showCancel
                />
            )
        );
    };


    function verif(id, e) {
        dispatch(verifExistance({ id })).then((val) => {
            var test = val.payload.test
            confirmMessage(id, e, test)
        });
    }


    function deleteImsNat(id, e) {
        dispatch(ImsNatDeleted({ id })).then((val) => {
            notify(1, "Ims nat supprimé avec succées")
            getImsNat();
            hideAlert();
        });
    }


    const getImsNat = useCallback(
        async () => {
            var root = await dispatch(fetchImsNatForListe({ annee: ans, client }));
            const extractedData = root.payload.map(item => {
                const mois = item.mois;
                const moisNoms = [
                    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                    "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"
                ];

                if (mois >= 1 && mois <= 12) {
                    return {
                        createdAt: item.createdAt.substring(0, 10),
                        nom_file: item.filename,
                        titre: item.titre,
                        id: item.id,
                        mois: moisNoms[mois - 1],
                        annee: item.annee,

                    };
                }

                return null; // Gérer les cas invalides ici
            });

            setLoader(false);
            setEntities(extractedData.filter(item => item !== null)); // Filtrer les éléments nuls
        },
        [dispatch]
    );

    function listepp() {
        navigate.push(client + "/ExtractionImsNat");
    }

    useEffect(() => {
        getImsNat();
    }, [getImsNat]);

    return (
        <>
            {alert}
            <Container fluid>
                <ToastContainer />
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-plus"></i>
                            </span>
                            Ajouter ims nat
                        </Button>
                    </Col>
                    <Col md="12">

                        <Card className="card-header">
                            <Card.Header><h4 className="title">Liste des ims nat</h4></Card.Header>

                            <Card.Body>

                                <MaterialReactTable
                                    state={{ isLoading: loader }}
                                    columns={columns}
                                    data={entities}
                                    enableColumnActions={true}
                                    enableColumnFilters={true}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableBottomToolbar={true}
                                    enableTopToolbar={true}
                                    muiTableBodyRowProps={{ hover: false }}
                                    displayColumnDefOptions={{
                                        'mrt-row-numbers': {
                                            size: 10,
                                        },
                                        'mrt-row-expand': {
                                            size: 10,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    initialState={{
                                        columnVisibility: { description: false },
                                        density: 'compact',
                                        showGlobalFilter: true,
                                    }}


                                    filterFns={{
                                        myCustomFilterFn: (row, id, filterValue) => {
                                            const value = row.getValue(id);
                                            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
                                        },
                                    }}
                                    globalFilterFn="myCustomFilterFn"

                                    muiSearchTextFieldProps={{
                                        placeholder: t("search"),
                                        sx: { minWidth: '18rem' },
                                        variant: 'outlined',
                                    }}
                                    localization={
                                        lang === "fr"
                                            ? MRT_Localization_FR
                                            : MRT_Localization_EN
                                    }
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default list_ImsNat;
